import {SET_PERMISSIONS} from "./types.js";
import service from '../providers/service.js';
import {tokenize} from "../helpers/token.js";

export function fetchPermissionsForRoles(roleIds) {
    return (dispatch) => {
        service
            .post(tokenize('/api/permissions/for-roles'), {roles: roleIds})
            .then(response => {
                // Save permissions to redux store
                dispatch(setPermissions(response.data.permissions));
            }).catch((err) => {
            console.log(err);
        })
    }
}

function setPermissions(permissions) {
    return {
        type: SET_PERMISSIONS,
        permissions: permissions
    };
}


// WEBPACK FOOTER //
// ./src/actions/permissions.js